import { GET_MENU } from "../const";

export const getMenu = (data: any) => {
    return {
        type: GET_MENU,
        payload: data,
    };
};
